var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB90D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3730B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "4.74679129%",
    fx: "50%",
    fy: "4.74679129%",
    r: "72.2635651%",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF9CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF04C",
    offset: "44.0876695%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB90D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.6088169%",
    cy: "28.2345201%",
    fx: "52.6088169%",
    fy: "28.2345201%",
    r: "66.9649907%",
    gradientTransform: "translate(0.526088,0.282345),scale(1.000000,0.842317),rotate(80.459998),translate(-0.526088,-0.282345)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#995723",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633917",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-67.000000, -97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(66.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 14.5,
    cy: 14.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#radialGradient-2)",
    cx: 14.5,
    cy: 14.5,
    r: 13.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.500000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.811542787,5.82604658 C1.22799209,6.55120908 1.73106523,4.07383091 2.86349608,4.07383091 C3.99592693,4.07383091 4.41004862,6.95499742 4.76346973,5.69603097 C5.11689084,4.43706452 4.92075496,0.670776367 2.7887043,0.670776367 C0.656653631,0.670776367 0.395093482,5.10088408 0.811542787,5.82604658 Z",
    id: "Path-2",
    fill: "#613A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07882887,5.32874036 C1.36391444,5.86621735 1.77359885,3.77877252 2.83995948,3.77877252 C3.90632012,3.77877252 4.38676392,5.92776145 4.64537165,5.1563311 C4.90397937,4.38490075 4.48613997,0.848795369 2.75882546,0.982176664 C1.03151095,1.11555796 0.793743304,4.79126337 1.07882887,5.32874036 Z",
    id: "Path-2",
    fill: "url(#radialGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(19.000000, 12.500000) scale(-1, 1) translate(-19.000000, -12.500000) translate(16.500000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.811542787,5.82604658 C1.22799209,6.55120908 1.73106523,4.07383091 2.86349608,4.07383091 C3.99592693,4.07383091 4.41004862,6.95499742 4.76346973,5.69603097 C5.11689084,4.43706452 4.92075496,0.670776367 2.7887043,0.670776367 C0.656653631,0.670776367 0.395093482,5.10088408 0.811542787,5.82604658 Z",
    id: "Path-2",
    fill: "#613A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07882887,5.32874036 C1.36391444,5.86621735 1.77359885,3.77877252 2.83995948,3.77877252 C3.90632012,3.77877252 4.38676392,5.92776145 4.64537165,5.1563311 C4.90397937,4.38490075 4.48613997,0.848795369 2.75882546,0.982176664 C1.03151095,1.11555796 0.793743304,4.79126337 1.07882887,5.32874036 Z",
    id: "Path-2",
    fill: "url(#radialGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0499956682,1.07883026 C0.340601093,0.723397475 2.05426025,1.73989156 3.93035889,2.21018626 C5.80645752,2.68048096 6.69453885,2.8494873 9.21342572,2.8494873 C11.7323126,2.8494873 12.9313674,2.58917627 14.2409333,2.21018626 C16.6525269,1.51226807 17.9824829,0.342224121 18.3727417,0.994995117 C18.7630005,1.64776611 17.6554161,4.6645177 15.4496736,6.96018626 C13.8075652,8.66924184 11.1766747,9.62083079 9.21342572,9.62083079 C7.17390077,9.62083079 4.25672307,8.75781282 2.56771555,6.96018626 C0.446991737,4.70308 -0.197348231,1.38135088 0.0499956682,1.07883026 Z",
    id: "Path-3",
    fill: "#613A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04456497,2.07883026 C1.30360383,1.72339747 2.34760248,2.69629636 4.61364746,3.21018626 C5.81238715,3.48203444 6.96393394,3.66760254 9.20827696,3.66760254 C11.45262,3.66760254 11.894648,3.5631028 14.1081543,3.0489502 C16.3216606,2.5347976 17.2120808,1.71570783 17.3922719,2.07883026 C17.5540062,2.40475843 16.3900466,5.17537969 14.7215576,6.53186035 C13.0530686,7.88834101 11.4913095,8.73126221 9.20969333,8.73126221 C6.92807712,8.73126221 5.12811279,8.29388428 3.35583496,6.61810303 C1.58355713,4.94232178 0.824088411,2.38135088 1.04456497,2.07883026 Z",
    id: "Path-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67114258,5.66495624 C3.15766264,6.01444228 5.6324036,6.66025391 8.84375,6.66025391 C12.0550964,6.66025391 14.6311228,6.00785301 15.3572998,5.66495624 C16.8236084,4.97257342 17.4151611,3.82145038 15.7861328,4.74320331 C14.9465422,5.2182688 11.8966821,5.81233095 8.84375,5.79770508 C5.79081787,5.78307921 3.09292992,5.18989074 2.25817871,4.74320331 C0.535644531,3.82145038 1.70727539,4.97257342 2.67114258,5.66495624 Z",
    id: "Path-4",
    fill: "#613A19"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/1.9087aaa4c5f93a9707385955b49afda9.svg";